/**
 * @generated SignedSource<<d56e91be4f10e4c12d56ce384666009d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppAssetId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stage",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTitle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetOrder",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetLink",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VppAssetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateVppAssetTPayload",
        "kind": "LinkedField",
        "name": "createVppAssetT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppAssetT",
            "kind": "LinkedField",
            "name": "vppAssetT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VppAssetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateVppAssetTPayload",
        "kind": "LinkedField",
        "name": "createVppAssetT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppAssetT",
            "kind": "LinkedField",
            "name": "vppAssetT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fafdc3ed559d3fc24f34b38116ebf13",
    "id": null,
    "metadata": {},
    "name": "VppAssetCreateMutation",
    "operationKind": "mutation",
    "text": "mutation VppAssetCreateMutation(\n  $input: CreateVppAssetTInput!\n) {\n  createVppAssetT(input: $input) {\n    vppAssetT {\n      vppAssetId\n      stage\n      assetType\n      assetTitle\n      assetOrder\n      assetLink\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "2af8c25ec986af07328415da9c2ab217";

module.exports = node;
